import { notification } from "antd";
import styled from "@emotion/styled";

const ToastAlert = (message: string) => {
  const formattedMessage = message.split("\n").map((line, index) => (
    <span key={index}>
      {line}
      {index < message.split("\n").length - 1 && <br />}
    </span>
  ));

  notification.open({
    message: "", // 빈 메시지 추가 (필수 속성)
    description: <ToastContainer>{formattedMessage}</ToastContainer>,
    duration: 3,
    placement: "top",
    style: {
      backgroundColor: "transparent", // 투명하게 설정
      border: "none",
      borderRadius: "10px",
      padding: "0",
      boxShadow: "none", // 중복 그림자 제거
      position: "fixed",
      top: "70%",
      left: "50%",
      transform: "translate(-50%, -40%)",
      zIndex: 9999,
    },
    closeIcon: null, // 닫기 버튼 제거 (선택사항)
  });
};

export default ToastAlert;

const ToastContainer = styled.div({
  padding: "15px",
  backgroundColor: "#262626",
  borderRadius: "10px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  alignItems: "flex-start",
  color: "white",
  fontSize: "16px", // text-base
  fontWeight: 500, // font-medium
  fontFamily: "Pretendard",
  textAlign: "left", // 왼쪽 정렬로 변경
  width: "100%",
});
